﻿myApp.directive('cus', function () {
    return {
        link: function (scope, elm) {
            //console.log('eee', elm);
            if (scope.$last) {
                scope.checkDevice();
                scope.loadImage();
                $(window).on("resize", scope.checkDevice);
            }
        }
    }
});

myApp.controller("customersCtrl", ['$scope', '$http', function ($scope, $http) {
    $scope.Customers = [];
    $scope.collpased = true;
    $scope.amount = 24;
    $scope.minRows = 3;
    $scope.maxRows = 0;
    $scope.rowHeigt = 0;
    $scope.IsImageLoaded = false;
    $scope.isDesktop = true;
    function setCustomers() {
        var prefix = "Costumers_";
        for (var i = 1; i <= $scope.amount; i++) {
            var fullname = prefix + i;
            $scope.Customers.push(fullname);
        }
    }
    setCustomers();
    $scope.loadImage = function () {
        $(".customers-ctrl img").first().on("load", function () {
            if (!$scope.IsImageLoaded) {
                $scope.IsImageLoaded = true;
                $scope.rowHeigt = this.height;
                $scope.hideRows();

            }
        });;
    }
    $scope.hideRows = function () {
        console.log("hide rows");
        if (innerWidth > 992) {
            $scope.rowHeigt += 45;
        }
        else {
            $scope.rowHeigt += 10;
        }
        var totalHeight = $scope.minRows * $scope.rowHeigt;
        $(".customers-ctrl").css("overflow-y", "hidden");
        $(".customers-ctrl").height(totalHeight);
        $scope.comeIn();

    }

    $scope.moreClients = function () {
        if ($scope.collpased) {
            var toDivide;
            if (innerWidth > 900) {
                toDivide = 5;
            } else {
                toDivide = 3;
            }

            $(".customers-ctrl").animate({
                "height": $scope.amount / toDivide * $scope.rowHeigt
            });
            $scope.collpased = false;
        }
        else {
            $scope.collpased = true;
            var totalHeight = $scope.minRows * $scope.rowHeigt;
            $(".customers-ctrl").animate({
                "height": totalHeight
            });
        }
    }
    $scope.checkDevice = function () {
        var width = 0;
        var toDivide = 0;
        if (innerWidth > 900) {
            $scope.isDesktop = true;
            toDivide = 5.5;
            $scope.minRows = 3;
        } else {
            $scope.isDesktop = false;
            toDivide = 3.5;
            $scope.minRows = 4;
        }

        $(".customers-ctrl img").each(function () {
            width = $(".customers-ctrl").width() / toDivide;
            $(this).width(width);
            $scope.rowHeigt = this.height;
            $scope.hideRows();
        });
    }
    $scope.comeIn = function () {
 
        var win = $(window);
        var allMods = $(".cus-img");
        win.scroll(function (event) {
            allMods.each(function (i, el) {
                var el = $(el);
                if (el.visible(true)) {
                    el.addClass("fadeup");
                }
            });

        });
    }
}]);




//////////////////
// WEBPACK FOOTER
// ../scripts/yit/controllers/customers.js
// module id = 12
// module chunks = 0